export var MileageDataSource;
(function (MileageDataSource) {
    MileageDataSource["KEY_READER"] = "KEY_READER";
    MileageDataSource["REMOTE_KEY_READ"] = "REMOTE_KEY_READ";
    MileageDataSource["TELESERVICES"] = "TELESERVICES";
    MileageDataSource["VEHICLE_HISTORY"] = "VEHICLE_HISTORY";
    MileageDataSource["OVER_THE_AIR"] = "OVER_THE_AIR";
    MileageDataSource["MANUAL"] = "MANUAL";
    MileageDataSource["OTHER"] = "OTHER";
})(MileageDataSource || (MileageDataSource = {}));
//# sourceMappingURL=mileageDataSource.js.map